export default {"src":"/kaimono/_next/static/media/wamazing_h.03c2a9ea.svg","height":116,"width":338};